import gmb from "../../config/constantsGMB";

export const getToken = () => localStorage.getItem("access_token");

export const setToken = (params) => {
  console.info("setToken");
  console.info(params);
  console.info("LOCATION");
  console.info(location);
  if (params["#"]) {
    localStorage.setItem(
      params["#"].split("&")[1].split("=")[0],
      params["#"].split("&")[1].split("=")[1]
    );
    location.href = `${location.href.split("#")[0]}?authenticated=true`;
  } else if (!location.href.split("?")[1]) {
    oauth2SignIn();
  }
};

export const setTokenToLocalStorage = (params) => {
  console.info("SETTokenToLocalStorage");
  console.info(params);
  console.info("LOCATION");
  console.info(location);
  if (params["#"]) {
    localStorage.setItem(
      params["#"].split("&")[1].split("=")[0],
      params["#"].split("&")[1].split("=")[1]
    );
    location.href = `${location.href.split("#")[0]}`;
  }
};

const oauth2SignIn = () => {
  const oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth";

  let form = document.createElement("form");
  form.setAttribute("method", "GET");
  form.setAttribute("action", oauth2Endpoint);

  const params = {
    client_id: gmb.clientId,
    redirect_uri: gmb.redirectUri,
    scope: gmb.scope,
    state: "try_sample_request",
    include_granted_scopes: "true",
    response_type: "token",
  };

  for (let p in params) {
    let input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", p);
    input.setAttribute("value", params[p]);
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
};



// WEBPACK FOOTER //
// ./client/app/components/unit/unit.helper.js